<template>
<div class=""> <!-- max-w-7xl mx-auto sm:p-6 lg:px-8 -->
  <div class="bg-blue-100 lg:rounded-lg">
    <div class="px-4 py-5 sm:p-6">
        <!-- Content goes here -->
      
      <form @submit.prevent="onSearch" class="space-y-6">

        <div class="space-y-1">
          <label for="initialbox" class="block text-sm font-medium text-gray-700">Search by subject or level</label>
          <VSelect
            ref="initialbox"
            v-model="initial"
            :options="initialListItems"
            label="Description"
            @input="onInitialSelected"
            @search="onInitialInput"
            placeholder="What would you like help with?"
            class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md search-panel"
          >
            <template #no-options="{ search, searching }">
                <div class="text-left pl-3">
                    <template v-if="searching">
                        No results found for <em>{{ search }}</em>.
                    </template>
                    <em v-else style="opacity: 0.5">e.g. Maths, English, GCSE, 11+</em>
                </div>
            </template>
          </VSelect>
          <p v-if="$v.initial.$dirty && !$v.initial.required" class="text-red-600">Please enter a subject or level.</p>
        </div>

        <div class="space-y-1" :class="{ 'opacity-40 italic': !initial }">
          <label for="refineInput" class="block text-sm font-medium text-gray-700">Refine</label>
          <VSelect 
            ref="refineInput"
            v-model="refine"
            :options="refinementList"
            label="Description"
            @search="onRefineInput"
            :placeholder="!initial ? 'Choose a subject/level…' : initial.Type === 'SUBJECT' ? 'Choose a level' : 'What subject?'"
            :disabled="!initial"
            class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md search-panel"
          >
            <template #no-options="{ search, searching }">
                <div class="text-left pl-3">
                    <template v-if="searching">
                        No results found for <em>{{ search }}</em>.
                    </template>
                    <em v-else style="opacity: 0.5">
                        {{ initial.Type === 'SUBJECT' ? 'e.g. Key Stage 2, GCSE, Bachelors' : 'e.g. Maths, English, Astronomy' }}
                    </em>
                </div>
            </template>
          </VSelect>
        </div>

          <!-- <model-select v-model="initial"
                        :options="initialList">
          </model-select> -->

          <!-- <model-select v-model="subject"
                        :options="subjectList">
          </model-select> -->

          <!-- <model-select v-model="level"
                        :options="levelsList">
          </model-select> -->

        <div class="space-y-1">
          <label for="location" class="block text-sm font-medium text-gray-700">Location</label>
          <VueGoogleAutocomplete 
            v-if="googleHasLoaded"
            ref="location"
            id="location"
            placeholder="Location"
            types=""
            country="gb"
            @placechanged="onPlaceChanged"
            class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
          />
        </div>

        <div>
          <toggle
            v-model="happyToLearnOnline"
          >
            Include online matches
          </toggle>
        </div>

        <div>
          <toggle
            v-model="studentPreparedToTravel"
            :labelClickEnabled="false"
            labelClass="flex items-center space-x-1"
          >
            <span>I</span>
            <span class="hidden sm:inline">am prepared to</span>
            <span class="sm:hidden">can</span>
            <span>travel</span>
            <select 
              v-model.number="numberOfMilesStudentPreparedToTravel" 
              class="p-0 font-medium text-center border-none bg-none bg-transparent" 
              :class="[studentPreparedToTravel ? 'text-blue-600' : 'text-gray-500']"
              :disabled="!studentPreparedToTravel"
              style="appearance: auto"
            >
              <option value="1">1</option>
              <option value="3">3</option>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
            </select>
            <span>mile{{ numberOfMilesStudentPreparedToTravel === 1 ? '' : 's' }}</span>
          </toggle>
        </div>

        <div class="flex flex-col space-y-1 sm:flex-row sm:items-center sm:space-y-0 sm:space-x-3">
          <toggle v-model="mustAcceptStripe">
            Only show tutors who accept
          </toggle>
          <PayWithStripeBadge class="ml-14" />
        </div>

        <div>
          <toggle v-model="mustHavePassedDbsCheck">
            Only show tutors who have passed our DBS Check
          </toggle>
        </div>
        
        <div class="flex flex-col space-y-2 sm:flex-row sm:items-center sm:space-y-0 sm:space-x-2">
          <toggle v-model="residesIn">
            Only show tutors who reside in
          </toggle>
          <select 
            v-model="residenceCountry"
            :disabled="!residesIn"
            class="ml-14 rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
          >
            <option v-for="country of countries" :key="country">
              {{ country }}
            </option>
          </select>
        </div>

        <div class="space-y-1">
          <label for="tutorsName" class="block text-sm font-medium text-gray-700">Tutors name</label>
          <input type="text" v-model="tutorsName" placeholder="Name"
            class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
          />
        </div>

        <button class="inline-flex items-center px-6 py-3 text-base border shadow-sm font-medium rounded-md bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 border-transparent text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50">
          Search
        </button>

      </form>

    </div>
  </div>
</div>
</template>
<script>
    
    import Vue from 'vue';
    import debounce from 'debounce'
    import VueGoogleAutocomplete from 'vue-google-autocomplete'
    // import { ModelSelect } from 'vue-search-select'
    import vSelect from 'vue-select'

    // import 'vue-search-select/dist/VueSearchSelect.css'
    import 'vue-select/dist/vue-select.css'

    import SearchService from '@/services/SearchServices'
    import CountriesService from '../services/CountriesService'
    import Toggle from './Toggle.vue'
    import { requiredIf } from 'vuelidate/lib/validators'
    import StripeLogo from './StripeLogo.vue';
    import PayWithStripeBadge from './PayWithStripeBadge.vue';

    const searchService = new SearchService();
    const countriesService = new CountriesService()

    export default {
        components: {
            VueGoogleAutocomplete,
            // ModelSelect,
            'VSelect': vSelect,
            Toggle,
            StripeLogo,
            PayWithStripeBadge,
        },
        props: {
            subjectQuery: null,
            levelQuery: null,
            locationNameQuery: null,
            locationLatLngQuery: null
        },
        data() {
            return {
                initialSearchString: '',
                initial: null,
                initialList: [],
                refine: null,
                refinementList: [],
                noDrop: true,
                subject: this.subjectQuery || null,
                subjectList: [],
                level: this.levelQuery || null,
                levelsList: [],
                locationName: this.locationNameQuery,
                locationLatLng: this.locationLatLngQuery,
                googleHasLoaded: false,
                happyToLearnOnline: true,
                studentPreparedToTravel: true,
                numberOfMilesStudentPreparedToTravel: 10,
                tutorsName: null,
                mustAcceptStripe: false,
                mustHavePassedDbsCheck: false,
                countries: [],
                residesIn: false,
                residenceCountry: null,
            }
        },
        validations: {
          initial: {
            required: requiredIf(function() {
              return this.tutorsName === null || this.tutorsName === ''
            })
          }
        },
        computed: {
            selectedInitialItem() {
                return this.initialList.find(x => x.Id === this.initial?.id) || {}
            },
            selectedRefinedItem() {
                return this.refinementList.find(x => x.Id === this.refine?.id) || {}
            },
            initialListItems() {
                return this.initialList
                return this.initialList.length > 0
                    ? this.initialList
                    : [{
                        Id: 'MATHS',
                        Description: 'Maths',
                        Type: 'SUBJECT'
                    },
                    {
                        Id: 'ENGLISH',
                        Description: 'English',
                        Type: 'SUBJECT'
                    },
                    {
                        Id: 'SCIENCE',
                        Description: 'Science',
                        Type: 'SUBJECT'
                    }]
            },
            initialSearchValue() {
              return this.$refs?.initialbox?.search ?? ''
            }
        },
        methods: {
            // getSubjectLevels() {
            //     return searchService.getSubjectsAndLevels()
            //         .then((response) => {
            //             this.initialList = response.data;
            //         });
            // },
            async onInitialInput(searchStr, loadingCallback) {
                this.initialSearchString = searchStr

                loadingCallback(true)
                var response = await searchService.initialSearch(searchStr.trim())
                loadingCallback(false)
                
                this.initialList = response.data.results[0]?.Levels || []
            },
            async onInitialSelected(a) {
                // this.refinementList.unshift({ Id: null, Description: a.Type === 'SUBJECT' ? 'All Levels' : 'All Subjects' })
                // this.refine = this.refinementList[0]
                var response = await searchService.refineSearch(a.Type, a.Id, '')
                this.refinementList = response.data
                this.refine = this.refinementList[0]

                return
                if (a.Type === 'SUBJECT') {
                    await this.getLevels(a.Id)
                }
                else {
                    await this.getSubjects(a.Id)
                }

                this.refine = this.refinementList[0]
            },
            async onRefineInput(searchStr, loadingCallback) {
                loadingCallback(true)
                var response = await searchService.refineSearch(this.initial.Type, this.initial.Id, searchStr.trim())
                loadingCallback(false)

                this.refinementList = response.data
            },
            async getSubjects(levelId) {
                let response = await searchService.getSubjects(levelId)
                
                this.refinementList = response.data;
                this.refinementList.unshift({ Id: null, Description: 'All Subjects' })
            },
            async getLevels(subject) {
                let response = await searchService.getLevels(subject)
                
                this.refinementList = response.data
                this.refinementList.unshift({ Id: null, Description: 'All Levels' })
            },
            onPlaceChanged(addressData, place, id) {
                this.locationName = place.name;
                this.locationLatLng = { lat: addressData.latitude, lng: addressData.longitude };
            },
            onSearch() {
              this.$v.$touch()
              if (this.$v.$invalid) return

                this.$emit('onBeforeSearchNavigation');
                
                let query = {
                  p: 1
                }

                if (this.initial) query[this.initial.Type === 'SUBJECT' ? 's' : 'l'] = this.initial.Id
                if (this.initial && this.refine) query[this.initial.Type === 'SUBJECT' ? 'l' : 's'] = this.refine.Id
                if (this.locationName) query.loc = this.locationName
                if (this.locationLatLng) {
                  query.lt = this.locationLatLng.lat
                  query.lg = this.locationLatLng.lng
                }
                if (!this.happyToLearnOnline) query.o = this.happyToLearnOnline
                if (!this.studentPreparedToTravel) query.w = this.studentPreparedToTravel
                if (this.numberOfMilesStudentPreparedToTravel !== 10) query.d = this.numberOfMilesStudentPreparedToTravel
                if (this.tutorsName) query.n = this.tutorsName
                if (this.mustAcceptStripe) query.op = this.mustAcceptStripe
                if (this.mustHavePassedDbsCheck) query.dbs = this.mustHavePassedDbsCheck
                if (this.residesIn) query.r = this.residenceCountry

                //const query = {
                  //s: this.initial?.Type === 'SUBJECT' ? this.initial.Id : this.refine?.Id,
                  //l: this.initial?.Type === 'LEVEL' ? this.initial.Id : this.refine?.Id,
                  //loc: this.locationName,
                  //lt: this.locationLatLng?.lat,
                  //lg: this.locationLatLng?.lng,
                  //o: this.happyToLearnOnline,
                  //w: this.studentPreparedToTravel,
                  //d: this.numberOfMilesStudentPreparedToTravel,
                  //p: 1
                //}

                this.$router.push({ 
                  name: 'SearchResults',
                  query
                });
                this.$emit('onAfterSearchNavigation');
            },
            customFilterBy(option, label, search) {
                var labelMatch = (label || "").toLowerCase().indexOf(search.toLowerCase()) > -1;
                var altMatch = (option.AlternativeNames || "").toLowerCase().indexOf(search.toLowerCase()) > -1;
                debugger
                return labelMatch || altMatch;
            },
            getOptionLabel(a) {
                return this.initialList.find(x => x.Id === a.id).Description.toLowerCase().indexOf(this.initialSearchValue.toLowerCase()) > -1 
                    ? a.label 
                    : this.initialList.find(x => x.Id === a.id).AlternativeNames?.split(',').find(x => x.toLowerCase().indexOf(this.initialSearchValue.toLowerCase()) > -1)
            },
            async getCountries() {
              const response = await countriesService.get()
              this.countries = response.data
            }
        },
        watch: {
            subject(newVal) {
                this.getLevels(newVal).then((x) => {
                    if (!this.levelsList.some(x => x.value === this.level)) {
                        this.level = null;
                    }
                });
            },
            level(newVal) {
                this.getSubjects(newVal).then((x) => {
                    if (!this.subjectList.some(x => x.value === this.subject)) {
                        this.subject = null;
                    }
                });
            },
            googleHasLoaded() {
              
            }
        },
        created() {
            this.$loadScript("https://maps.googleapis.com/maps/api/js?key=AIzaSyAAsIATBbPpaX4NlWUJwaY0WZtXIt9dt20&libraries=places")
                .then(() => {
                    console.log("Google Maps loaded.");
                    this.googleHasLoaded = true;
                });
        },
        mounted() {
            //this.getSubjectLevels();
            // this.getSubjects();
            // this.getLevels();
            let initialFromQuery = this.$route.query.s ?? this.$route.query.l ?? null

            if (initialFromQuery) {
              searchService.initialSearch(initialFromQuery).then(response => {
                this.initial = response.data.results[0].Levels.find(x => x.Id === initialFromQuery)

                searchService.refineSearch(this.initial.Type, this.initial.Id, '').then(response2 => {
                  this.refinementList = response2.data
                  this.refine = this.refinementList[0]
                })
              })
            }
          

            if (this.$route.query.o) this.happyToLearnOnline = JSON.parse(this.$route.query.o)
            if (this.$route.query.w) this.studentPreparedToTravel = JSON.parse(this.$route.query.w)
            if (this.$route.query.d) this.numberOfMilesStudentPreparedToTravel = JSON.parse(this.$route.query.d)
            if (this.$route.query.n) this.tutorsName = this.$route.query.n
            if (this.$route.query.op) this.mustAcceptStripe = JSON.parse(this.$route.query.op)
            if (this.$route.query.dbs) this.mustHavePassedDbsCheck = JSON.parse(this.$route.query.dbs)
            if (this.$route.query.r) { this.residesIn = true; this.residenceCountry = this.$route.query.r } 
            
            this.$watch(() => this.googleHasLoaded, () => {
              if (this.$route.query.loc) {
                this.locationName = this.$route.query.loc
                this.locationLatLng = { lat: this.$route.query.lt, lng: this.$route.query.lg }
                this.$refs.location.update(this.locationName)
                this.$refs.location.updateCoordinates(this.locationLatLng)
              }
            })

            this.getCountries().then(() => {
              if (!this.residesIn) this.residenceCountry = this.countries[0]
            })


            // this.initialList.filter((x) => { return x.Id === this.subjectQuery })[0];
        }
    }

    

</script>
<style lang="scss">

  .search-panel {

    .noDrop .vs__dropdown-menu
    {
        display: none !important;
    }

    .vs__dropdown-toggle {
      padding: 0;
      background-color: #fff;
      box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
      border-radius: 0.375rem !important;
    }

    .vs__search, .vs__search:focus, .vs__selected {
      margin: 0;
      padding: 8px 12px;
    }

    .vs__selected-options {
      padding: 0;
    }

    .vs__search::placeholder {
      color: #6b7280;
    }

    .vs__actions {
      padding: 0 12px;
    }
    
    .vs--disabled .vs__search {
      background: transparent;
    }

  }

</style>